import { Delete, Download, ArrowForward, ArrowDownward, ArrowUpward, ViewAgenda, OpenInNew } from '@mui/icons-material';
import { Box, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TextField, Grid } from '@mui/material';
import { formatDateWhitoutHour, helpers } from '../../services/helpers/helpers';
import { MetaDadosProps } from '../../services/api/minio/Minio';
import { useMemo, useState } from 'react';
import SelectTypeFile from './SelectTypeFile';


import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

interface TableFilesProps {
	data: MetaDadosProps[],
	downloadFile: (uuid: string, view?: boolean) => void;
	navigate: (value: string) => void;
	delet: (value: string) => void;
	permissions: string;
}

export default function TableFiles({
	data,
	downloadFile,
	navigate,
	delet,
	permissions: permisions
}: TableFilesProps) {

	const [type, setType] = useState<string>('');
	const [name, setName] = useState<string>('');
	const [order, setOrder] = useState<'asc' | 'desc'>('desc');

	const filteredData = useMemo(() => {
		const sortedData = [...data];

		
		sortedData.sort((a, b) => {
			if (!a.data_emissao && !b.data_emissao) {
				return 0;
			}
			if (!a.data_emissao) {
				return 1;
			}
			if (!b.data_emissao) {
				return -1;
			}

			const [mesA, anoA] = a.data_emissao.split('/');
			const [mesB, anoB] = b.data_emissao.split('/');

			const dateA = new Date(Number(anoA), Number(mesA) - 1).getTime();
			const dateB = new Date(Number(anoB), Number(mesB) - 1).getTime();

			return order === 'asc' ? dateA - dateB : dateB - dateA;
		});

		return sortedData.filter((arquivo) => {
			const matchType =
				type === '' || arquivo.tipo.toLowerCase() === type.toLowerCase();
			const matchName =
				name === '' ||
				arquivo.descricao.toLowerCase().includes(name.toLowerCase());
			return matchType && matchName;
		});
	}, [data, type, name, order]);


	function handleSord() {
		if (order === 'asc') setOrder('desc');
		if (order === 'desc') setOrder('asc');
	}

	return (
		<Box>
			<Grid container spacing={2} paddingY={2}>
				<Grid item xs={4}>
					<SelectTypeFile
						onChange={(e) => setType(e)}
						value={type}
						error={false}
					/>
				</Grid>
				<Grid item xs={5}>
					<TextField
						label='Descrição do arquivo'
						onChange={(e) => setName(e.target.value)}
						value={name}
					/>
				</Grid>
			</Grid>
			<TableContainer component={Paper} variant='outlined' sx={{ borderRadius: '25px' }}>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell align='left'>Nome do arquivo</TableCell>
							<TableCell align='left'>Tipo</TableCell>
							<TableCell align='left'>Descrição</TableCell>
							<TableCell align='left' onClick={handleSord}>Data de inserção {order === 'asc' ? <ArrowDownward sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover', }, mb: -0.6 }} /> : <ArrowUpward sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'action.hover', }, mb: -0.6 }} />}</TableCell>
							<TableCell align='center'>Ação</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredData.map((arquivo) => (
							<TableRow key={arquivo.uuid} hover={true}>
								<TableCell align="left">{arquivo.nome_arquivo}</TableCell>
								<TableCell align="left">{arquivo.tipo}</TableCell>
								<TableCell align="left" sx={{ maxWidth: 250, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{arquivo.descricao}</TableCell>
								<TableCell align="left">
									{arquivo.data_emissao === null ? 'Sem data' : arquivo.data_emissao}
								</TableCell>
								<TableCell align="center">
									{permisions.includes('remove') &&
										<IconButton title='Deletar' onClick={() => delet(arquivo.uuid)}>
											<Delete />
										</IconButton>
									}
									{arquivo.nome_arquivo.includes('.pdf') &&
										<IconButton title='Abrir' onClick={() => downloadFile(arquivo.uuid, true)}>
											<OpenInNew />
										</IconButton>
									}
									{permisions.includes('view') &&
										<IconButton onClick={() => downloadFile(arquivo.uuid)}>
											<Download />
										</IconButton>
									}
									{permisions.includes('edit') &&
										<IconButton title='Editar' onClick={() => navigate(arquivo.uuid)}>
											<ArrowForward />
										</IconButton>
									}
								</TableCell>
							</TableRow>
						))}
						{filteredData.length === 0 && (
							<TableRow>
								<TableCell colSpan={4} align="center">
									Nenhum arquivo encontrado
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
}